import { GeneralService } from 'src/app/services/general.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { FormularioService } from 'src/app/services/formulario.service';
import { NotificationService } from 'src/app/services/notification.service';
import { HttpErrorResponse } from '@angular/common/http';
import {
  ActionMessage,
  TypeMessage,
} from 'src/app/entity/enum/enum-notification';
import { take } from 'rxjs/operators';
import { eSiteType } from 'src/app/entity/enum/enum-site-type';
import { ActivatedRoute } from '@angular/router';
import { eAreaType } from 'src/app/entity/enum/enum-area-type';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-cd001-card-limpeza-I',
  templateUrl: './cd001-card-limpeza-I.component.html',
})
export class Cd001CardLimpezaIComponent
  extends GeneralComponent
  implements OnInit {
  public formulario?: FormGroup;
  public listSite?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listHibrido?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listProcesso?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listDepositoOrigem?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listPeneiraTopo?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listPeneiraFundo?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

  public listPeneiraIntermediaria?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listPeneiraIntermediariaOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

  public listSiteOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listHibridoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listProcessoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listDepositoOrigemOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listPeneiraTopoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listPeneiraFundoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  @Output() mkCalc = new EventEmitter();
  @Output() objPC003 = new EventEmitter();

  public listTurno?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listTurnoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listLinhaReprocessamentoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listLinhaReprocessamento?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

  area: string = eAreaType.commercial;

  // tslint:disable-next-line: max-line-length
  constructor(
    protected formularioService: FormularioService,
    protected formBuilder: FormBuilder,
    protected notificationService: NotificationService,
    protected generalService: GeneralService,
    private route: ActivatedRoute
  ) {
    super('Dados do Lote em beneficiamento', false);
    if (this.isComercial) {
      this.formulario = this.formBuilder.group({
        site: [null, []],
        data: [null, [Validators.pattern(this.regexDate)]],
        hora: [null, [Validators.pattern(this.regexHour)]],
        numero_controle: [null, []],
        hibrido: [null, []],
        processo: [null, []],
        lote_origem: [null, [Validators.pattern('\^([a-zA-Z]{6}[0-9]{4})$|([a-zA-Z]{6}[0-9]{4}[;]{1})+([a-zA-Z]{6}[0-9]{4}[;]?)')]],
        deposito_origem: [null, []],
        umidade_ds_prc: [null, []],
        safra: [null, [Validators.required, Validators.pattern(this.regexSafra)]],
        peneira_topo: [null, []],
        peneira_fundo: [null, []],
        peneira_intermediaria: [null, []],
        turno: [null, []],
        basic: [null, []],
      });
    }
    else {
      this.formulario = this.formBuilder.group({
        site: [null, []],
        data: [null, [Validators.pattern(this.regexDate)]],
        hora: [null, [Validators.pattern(this.regexHour)]],
        numero_controle: [null, []],
        hibrido: [null, []],
        processo: [null, []],
        lote_origem: [null, []],
        deposito_origem: [null, []],
        umidade_ds_prc: [null, []],
        safra: [null, [Validators.required, Validators.pattern(this.regexSafra)]],
        peneira_topo: [null, []],
        peneira_fundo: [null, []],
        peneira_intermediaria: [null, []],
        basic: [null, []],
        numero_campo: [null, []],
        ajuste_1: [null, []],
        ajuste_2: [null, []],
        ajuste_3: [null, []],
        ajuste_4: [null, []],
        ajuste_5: [null, []],
        ajuste_6: [null, []],
        turno: [null, []],
      });
    }

  }

  public async ngOnInit(): Promise<void> {
    this.getArea();
    await this.getLists();
    this.enableInputs();
  }

  public changeCollapse(): void {
    this.collapseCard = this.collapseCard ? false : true;
  }

  public hasErrorFormControl(campoFormulario?: AbstractControl): string {
    return this.formularioService.hasErrorFormControl(campoFormulario);
  }

  public async getLists(): Promise<void> {
    await Promise.all([
      this.getListSite(),
      this.isComercial ? this.getHibridoDropdown() : null,
      this.getListProcesso(),
      this.getListDepositoOrigem(),
      this.getListPeneiraTopo(),
      this.getListPeneiraFundo(),
      this.getListPeneiraIntermediaria(),
      this.getListTurno()
    ]);
  }

  async getListSite(): Promise<void> {
    this.listSite = this.generalService.getListSiteRecebimento();
    this.listSiteOriginal = this.listSite;
    // await this.formularioService.getListDropDownList('qua007', 'site_origem').pipe(take(1)).toPromise().then(response => {
    //     if (!!response?.data) {
    //         this.listSite = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
    //         this.listSiteOriginal = this.listSite;
    //     }
    // }).catch(async (error: HttpErrorResponse) => {
    //     this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorSiteOrigem);
    // });
  }

  async getListHibrido(): Promise<void> {
    await this.formularioService
      .getListDropDownList('qua007', 'hibrido_rnc')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listHibrido = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listHibridoOriginal = this.listHibrido;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorHibrido
        );
      });
  }

  async getListProcesso(): Promise<void> {
    await this.formularioService
      .getListDropDownList('cd001', 'processo')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listProcesso = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listProcessoOriginal = this.listProcesso;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorProcesso
        );
      });
  }

  async getListDepositoOrigem(): Promise<void> {
    await this.formularioService
      .getListDropDownList('cd001', 'origem')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listDepositoOrigem = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listDepositoOrigemOriginal = this.listDepositoOrigem;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorDepositoOrigem
        );
      });
  }

  async getListPeneiraTopo(): Promise<void> {
    await this.formularioService
      .getListDropDownList('cd001', 'peneira_topo')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listPeneiraTopo = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listPeneiraTopoOriginal = this.listPeneiraTopo;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorPeneiraTopo
        );
      });
  }

  async getListPeneiraFundo(): Promise<void> {
    await this.formularioService
      .getListDropDownList('cd001', 'peneira_fundo')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listPeneiraFundo = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listPeneiraFundoOriginal = this.listPeneiraFundo;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorPeneiraFundo
        );
      });
  }

  async createFilterSite(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listSiteOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listSite = this.listSiteOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listSite = this.listSiteOriginal;
      }
    } else {
      this.listSite = this.listSiteOriginal;
    }
  }

  async createFilterHibrido(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listHibridoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listHibrido = this.listHibridoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listHibrido = this.listHibridoOriginal;
      }
    } else {
      this.listHibrido = this.listHibridoOriginal;
    }
  }

  async createFilterProcesso(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listProcessoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listProcesso = this.listProcessoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listProcesso = this.listProcessoOriginal;
      }
    } else {
      this.listProcesso = this.listProcessoOriginal;
    }
  }

  async createFilterDepositoOrigem(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listDepositoOrigemOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listDepositoOrigem = this.listDepositoOrigemOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listDepositoOrigem = this.listDepositoOrigemOriginal;
      }
    } else {
      this.listDepositoOrigem = this.listDepositoOrigemOriginal;
    }
  }

  async createFilterPeneiraTopo(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listPeneiraTopoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listPeneiraTopo = this.listPeneiraTopoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listPeneiraTopo = this.listPeneiraTopoOriginal;
      }
    } else {
      this.listPeneiraTopo = this.listPeneiraTopoOriginal;
    }
  }

  async createFilterPeneiraFundo(value?: string): Promise<void> {

    if (!!value && value.length > 0) {
      if (
        this.listPeneiraFundoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listPeneiraFundo = this.listPeneiraFundoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listPeneiraFundo = this.listPeneiraFundoOriginal;
      }
    } else {
      this.listPeneiraFundo = this.listPeneiraFundoOriginal;
    }
  }


  async createFilterPeneiraIntermediaria(value?: string): Promise<void> {

    if (!!value && value.length > 0) {
      if (
        this.listPeneiraIntermediariaOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listPeneiraIntermediaria = this.listPeneiraIntermediariaOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listPeneiraIntermediaria = this.listPeneiraIntermediariaOriginal;
      }
    } else {
      this.listPeneiraIntermediaria = this.listPeneiraIntermediariaOriginal;
    }
  }


  async getListPeneiraIntermediaria(): Promise<void> {

    await this.formularioService
      .getListDropDownList('cd001_prelimpeza', 'peneira_intermediaria')
      .pipe(take(1))
      .toPromise()
      .then((response) => {

        if (!!response?.data) {
          this.listPeneiraIntermediaria = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listPeneiraIntermediariaOriginal = this.listPeneiraIntermediaria;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListPeneiraIntermediaria
        );
      });
  }

  public async makeCalculations(): Promise<void> {
    this.mkCalc.emit();
  }

  getHibridoDropdown = async () => {
    if (this.area !== eAreaType.basic) {
      await this.getListHibrido();
    } else {
      await this.getListHibridoCDR();
    }
  };

  async getListHibridoCDR(): Promise<void> {
    await this.formularioService
      .getListHibridoDropdown()
      .then((res) => {
        this.listHibrido = res;
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorHibrido
        );
      });
  }

  getArea = () => {
    this.route.paramMap.subscribe((paramMap) => {
      this.area = paramMap.get('area');
    });
  };

  enableInputs = () => {
    switch (this.area) {
      case eAreaType.basic:
        this.formulario.controls.basic.enable();
        break;
      default:
        this.formulario.controls.basic.disable();
        break;
    }
  };

  getPc003Data() {
    // const contratoJuridico = this.formulario.get('contrato_juridico')?.value.trim()?.toUpperCase() as string;
    const safra = this.formulario.controls.safra.value

    const numeroCampo = this.formulario.controls.numero_campo.value
    // if (contratoJuridico != '' && contratoJuridico != null) {
    //     this.objPC003.emit(contratoJuridico)
    // }
    // else
    if ((safra != '' && safra != null) && (numeroCampo != '' && numeroCampo != null)) {
      this.objPC003.emit({ contratoJuridico: null, safra, numeroCampo })

    }
  }

  async getListTurno(): Promise<void> {
    await this.formularioService.getListDropDownList('cd001_repasse', 'turno').pipe(take(1)).toPromise().then(response => {
        if (!!response?.data) {
            this.listTurno = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            this.listTurnoOriginal = this.listTurno;
        }
    }).catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorTurno);
    });
}

  async createFilterLinhaReprocessamento(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (this.listLinhaReprocessamentoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
        this.listLinhaReprocessamento = this.listLinhaReprocessamentoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
      } else {
        this.listLinhaReprocessamento = this.listLinhaReprocessamentoOriginal;
      }
    } else {
      this.listLinhaReprocessamento = this.listLinhaReprocessamentoOriginal;
    }
  }

  async createFilterTurno(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (this.listTurnoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
        this.listTurno = this.listTurnoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
      } else {
        this.listTurno = this.listTurnoOriginal;
      }
    } else {
      this.listTurno = this.listTurnoOriginal;
    }
  }

}
